<template>
    <el-select v-model="model" placeholder="请选择" filterable @change="handleChange">
        <el-option label="不限" value="" v-if="hasAll"></el-option>
        <template v-for="(item, i) in list">
            <el-option v-if="typeof(model) == 'string'" :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>
            <el-option  v-else-if="typeof(model) == 'number'" :key="'ds-' + i" :label="item[label]" :value="parseInt(item[key])"></el-option>
            <el-option  v-else :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>
        </template>
<!--        <el-option v-for="(item, i) in list" :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>-->
    </el-select>
</template>

<script>
    // import axios from '@/util/api'

    export default {
        props: {
            value: {},
            param: {},
            form: {},
            cols: {},
            placeholder: {},
            hasAll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: '',
                list: [],
                key: '',
                label: '',
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.model = val
                    this.handleChange()
                },
                immediate: true
            },
            'param.param.api': {
                handler(api) {
                    // 如果告诉了接口
                    if (api) {
                        api().then(res => {
                            this.list = res;
                        })
                    }
                },
                immediate: true
            },
            'param.param.dict': {
                handler(val) {
                    // 如果是字典表
                    if (val) {
                        this.$api.post('sys/dict/selectDictItemListByDict', {dataCode: val})
                            .then(res => {
                                this.key = 'itemDataCode'
                                this.label = 'itemDataName'
                                this.list = res
                            })
                    }
                },
                immediate: true
            },
            model() {
                this.$emit('input', this.model)
            }
        },
        created() {
            if (!this.param.param) {
                return ''
            }

            const select = this.param.param
            this.key = select.key || 'key'
            this.label = select.value || 'value'
            if (select.list) {
                // 静态列表数据
                this.list = select.list;

                this.handleChange()
            }
        },
        methods: {
            handleChange(event) {
                if (this.param.param.change) {
                    this.param.param.change(this.model, this.cols, this.form, event !== undefined)
                }
                if (event) {
                    this.$emit('change', this.model);
                }

            }
        }
    }
</script>